// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-compliments-and-complaints/form-item-compliments-and-complaints.component.scss
// module id = 884
// module chunks = 0